import { render } from "./HelpPanelPaginationComponent.vue?vue&type=template&id=3ed7a15c&scoped=true"
import script from "./HelpPanelPaginationComponent.vue?vue&type=script&lang=js"
export * from "./HelpPanelPaginationComponent.vue?vue&type=script&lang=js"

import "./HelpPanelPaginationComponent.vue?vue&type=style&index=0&id=3ed7a15c&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed7a15c"]])

export default __exports__